import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import apiTestTrainings from "../../../api/apiTestTrainings";
import QuestionContainer from "./flow/QuestionContainer";
import { NavLink, withRouter } from "react-router-dom";
import store from "../../../localStorage";
import Question from "../../screens/questions/flow/Question";
import SuccessVisual from "../../screens/questions/SuccessVisual";
import FailVisualAndInjurie from "../../screens/questions/FailVisualAndInjurie";
import FailVisual from "../../screens/questions/FailVisual";
import {addBreamb, goBackStep} from "../../../reducers/breams-manage";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faForward, faRedo, faStop, faStopCircle } from "@fortawesome/free-solid-svg-icons";
import ExitTimer from "../../blocks/ExitTimer";
import Fail from "../../screens/questions/Fail";
import StepperNav from "../../blocks/StepperNav";
import TrainingResultView from "../../screens/questions/TrainingResultView";
import { normalizeModeSettings, prepareQuestions , formatTime} from "../../../helpers/functions";
import "./QuestionsTrainingContainer.css";
import Timer from "../../blocks/Timer";
import TrainingTimer from "../../blocks/TrainingTimer";
import Loader from "../../blocks/Loader";
import {pageLoadManageActions as loader} from "../../../reducers/load";
import ConfirmationDialog from "../../blocks/ConfirmationDialog";


class QuestionsTrainingContainer extends Component {
    constructor(props) {
        super(props);

        const settings = normalizeModeSettings(props.modeSettings);
        const activeQuestions = prepareQuestions(props.questions || [], settings);

        this.state = {
            content: Question,
            isLoading: false,
            testStartedAt: Date.now(),
            testFinishedAt:null,
            selectedQuestions: this.props.questions || [],
            mode: this.props.mode,
            activeQuestions,
            modeSettings: settings,
            targetQuestion: null,
            currentIndex: 0,
            is_exit_timer: true,            
            questionsCache: {},
            additionalButton:null,
            select_answer:null,
            show_exit_timer: false,
            is_last_question:false,
            results: {},
            questionStartedAt: {}, 
            trainingIsFinished:false,
            timeLeft: settings.timeLimit, // null или секунды
            timerId: null,
            showFinishConfirm: false,
        };
        store.dispatch({ type: "PAGE_LOADED", loadId: "question_trainings" });
        document.title = props.t("Trainings");
    }
    openFinishConfirm = () => {
        if (!this.state.is_exit_timer) return;
        this.setState({ showFinishConfirm: true });     
        
    };

    closeFinishConfirm = () => {
        this.setState({ showFinishConfirm: false });
    };

    confirmFinish = () => {
        this.setState({ showFinishConfirm: false }, () => {
            this.handleFinish();
            this.renderAdditionalButton(null);
        });
    };
    componentDidMount() {
        loader.start("question_training_container"); 
        // грузим первый вопрос при монтировании
        this.loadQuestionByIndex(0).finally(()=>{
            loader.stop("question_training_container");
            if (this.state.modeSettings.timeLimit != null) {
            this.startTimer();
        }
        });
        
    }
    componentWillUnmount() {
        if (this.state.timerId != null) {
            clearInterval(this.state.timerId);
        }
    }

    startTimer = () => {
        const id = setInterval(() => {
            this.setState(
                (prev) => {
                    const next = (prev.timeLeft ?? 0) - 1;

                    if (next <= 0) {
                        clearInterval(id);
                        return { timeLeft: 0, timerId: null };
                    }
                    return { timeLeft: next };
                },
                () => {
                    // колбэк после setState: если время вышло — завершаем
                    if (this.state.timeLeft === 0 && this.state.timerId === null) {
                        this.handleFinish();
                    }
                }
            );
        }, 1000);

        this.setState({ timerId: id });
    };

    /**
     * Возвращает id вопроса по индексу, либо null
     */
    getQuestionIdByIndex = (index) => {
        const { activeQuestions } = this.state;
        if (!activeQuestions || index < 0 || index >= activeQuestions.length) return null;
        return activeQuestions[index].questionID ?? activeQuestions[index].questionId;
    };

    /**
     * Загружает вопрос по id через API.
     * Если уже в кеше — возвращает из кеша.
     */
    loadingQuestion = async (questionId) => {
        if (questionId == null) return null;
        const cached = this.state.questionsCache[questionId];
        if (cached) return cached;
        const result = await apiTestTrainings.getQuestion(questionId);
        const question = result?.data ?? null;        
        if (question) {
            this.setState((prev) => ({
                questionsCache: { ...prev.questionsCache, [questionId]: question },
            }));
        }
        return question;
    };

    /**
     * Загружает вопрос по индексу, кладёт его в targetQuestion
     * и запускает prefetch следующего.
     */
    loadQuestionByIndex = async (index) => {       
        this.renderAdditionalButton(
                    <div className="d-flex w-100 justify-content-end">
                        <Button
                            className="MuiButton Btn Btn_danger ml-3"
                            onClick={this.openFinishConfirm}
                        >
                            <FontAwesomeIcon className="mr-4" icon={faStopCircle} />
                            {this.props.t('Завершить тренировку')}
                        </Button>
                    </div>
                );
        const questionId = this.getQuestionIdByIndex(index);
        if (questionId == null) return;

        const { activeQuestions } = this.state;
        const isLast = index === activeQuestions.length - 1;
        // фиксируем момент первого касания вопроса
        this.setState((prev) => ({
            isLoading: true,
            is_last_question: isLast,
            questionStartedAt: prev.questionStartedAt[questionId]
                ? prev.questionStartedAt
                : { ...prev.questionStartedAt, [questionId]: Date.now() },
        }));
        try {
            const question = await this.loadingQuestion(questionId);

            this.setState({
                targetQuestion: question,
                currentIndex: index,
                isLoading: false,
                content:Question
            });

            this.prefetchNext(index);
        } catch (e) {
            console.error('Ошибка загрузки вопроса:', e);
            this.setState({ isLoading: false });
        }
    };

    /**
     * Фоновая подгрузка следующего вопроса (без установки в targetQuestion).
     */
    prefetchNext = (currentIndex) => {
        const nextId = this.getQuestionIdByIndex(currentIndex + 1);
        if (nextId == null) return;
        // просто прогреваем кеш, ошибки игнорируем
        this.loadingQuestion(nextId).catch(() => {});
    };

    /**
     * Переход к следующему вопросу.
     * Если он уже в кеше — отдаётся мгновенно.
     */
    goToNext = () => {
        if (this.state.trainingIsFinished) return;
        const nextIndex = this.state.currentIndex + 1;
        if (this.getQuestionIdByIndex(nextIndex) == null) {
            this.handleFinish();
            return;
        }
        this.loadQuestionByIndex(nextIndex);
        
    };

    goToPrev = () => {
        const prevIndex = this.state.currentIndex - 1;
        if (prevIndex < 0) return;
        this.loadQuestionByIndex(prevIndex);
    };
    renderButtons = (is_right, selected_answer_or_array)=>{
        const selected_answer = selected_answer_or_array instanceof Array ? selected_answer_or_array[0] : selected_answer_or_array;
        const quote_from_document = this.props.targetQuestion?.question?.quote_from_document;                
        const sec = 10;
        const exitSec = quote_from_document ? 20 : sec;
        if (is_right) {
            if(this.state.is_last_question){
                this.renderAdditionalButton(
                    <div className="d-flex w-100 justify-content-end">                                            
                        <Button className="MuiButton Btn Btn_success ml-3"
                                onClick={() => {
                                    if (this.state.is_exit_timer) {
                                        this.handleFinish();
                                        this.renderAdditionalButton(null); }}}>
                            <FontAwesomeIcon className="mr-4" icon={faForward}/>
                            {this.props.t('Go to results')}
                            <ExitTimer theme_name={this.props.theme_name} goOut={this.handleFinish} handleExitTimer={this.handleExitTimer} sec={sec} />
                        </Button>
                    </div>
                );
            }else{
            this.renderAdditionalButton(
                                <div className="d-flex w-100 justify-content-end">
                                    <Button className="MuiButton Btn Btn_success"
                                            onClick={() => {
                                                if (this.state.is_exit_timer) {
                                                    this.renderAdditionalButton(null);
                                                    this.goToNext(); }}}>
                                        <FontAwesomeIcon className="mr-4" icon={faForward}/>
                                        {this.props.t('Next question')}                                        
                                        <ExitTimer theme_name={this.props.theme_name} goOut={this.goToNext} handleExitTimer={this.handleExitTimer} sec={sec} />
                                    </Button>                                   
                                </div>);
            }
        }else{
            this.renderAdditionalButton(
                    <Button className="MuiButton Btn Btn_success" onClick={() => {if (this.state.is_exit_timer) this.repeatQuestion()}} >
                        <FontAwesomeIcon className="mr-4" icon={faRedo}/>
                        {this.props.t('Try again')}
                        {(!selected_answer?.hasOwnProperty('injurie') || this.state.show_exit_timer) &&
                            <ExitTimer theme_name={this.props.theme_name} goOut={this.repeatQuestion} handleExitTimer={this.handleExitTimer} sec={exitSec}/>}
                    </Button>);
        }
    }
    onSelectAnswer = (answer_id) => {
        if (this.state.trainingIsFinished) return;
        const { targetQuestion, results  } = this.state;

        if (!targetQuestion || !Array.isArray(targetQuestion.answers)) {
            console.warn('onSelectAnswer: вопрос ещё не загружен или нет ответов');
            return;
        }

        const selectedAnswer = targetQuestion.answers.find(
            (answer) => answer.id === answer_id
        );

        if (!selectedAnswer) {
            console.warn(`onSelectAnswer: ответ с id=${answer_id} не найден`);
            return;
        }

        const questionId = targetQuestion.question?.question_id;
        if (!questionId) {
            console.warn('onSelectAnswer: у вопроса нет id');
            return;
        }

        const prevAttempts = results[questionId] || [];
        const newAttempt = {
            answer_id: selectedAnswer.id,
            is_right: selectedAnswer.is_right === true,
            answered_at: Date.now(),
            attempt_number: prevAttempts.length + 1,
        };
        const newResults = {
            ...results,
            [questionId]: [...prevAttempts, newAttempt],
        };
         
        this.setState({select_answer:selectedAnswer});
        const is_right = selectedAnswer.is_right;
        this.setState({ results: newResults }, () => {
            /*if (newAttempt.is_right) {
                if (this.state.is_last_question) {
                    this.finishTest();
                } else {
                    this.goToNext();
                }
            }*/
        });

        if (is_right) {     
            this.setState({ content: SuccessVisual });
            addBreamb({title: this.props.t('Answered correctly')});
            this.renderButtons(is_right, selectedAnswer);
        } else {
            if (!is_right) {
                
            };

            store.dispatch({type: 'PRESHIFT_FAIL'});            
            this.setState({ content: selectedAnswer?.hasOwnProperty('visualisation')
                ? (selectedAnswer?.hasOwnProperty('injurie')) ? FailVisualAndInjurie : FailVisual
                : Fail
            })

            addBreamb({title: this.props.t('Answered incorrectly')});

            this.renderButtons(is_right, selectedAnswer);
        }
       
    };
    repeatQuestion = ()=>{
        this.setState({content:Question});
        this.renderAdditionalButton(null);
    }
    handleFinish = ()=>{
         if (this.state.trainingIsFinished) return;
        if (this.state.timerId != null) {
            clearInterval(this.state.timerId);
        }
        this.setState({
            trainingIsFinished: true,
            testFinishedAt: Date.now(),
            timerId: null            
        });            
    }
    formatDuration = (ms) => {
        if (!Number.isFinite(ms) || ms < 0) return '0:00';
        const totalSec = Math.floor(ms / 1000);
        const h = Math.floor(totalSec / 3600);
        const m = Math.floor((totalSec % 3600) / 60);
        const s = totalSec % 60;
        const mm = String(m).padStart(2, '0');
        const ss = String(s).padStart(2, '0');
        return h > 0 ? `${h}:${mm}:${ss}` : `${m}:${ss}`;
    };
    handleSaveResult = async () => {
        const {
            results,
            activeQuestions,
            questionsCache,
            questionStartedAt,
            testStartedAt,
            testFinishedAt,
        } = this.state;

        const {
            employee,
            trainingType,
            trainingTypeName,
        } = this.props;
        
        // --- общее время ---
        const finishedAt = testFinishedAt || Date.now();
        const totalDurationMs = Math.max(0, finishedAt - (testStartedAt || finishedAt));

        // --- агрегаты и result[] ---
        let correctCount = 0;
        let wrongCount = 0;
        let unansweredCount = 0;

        const result = activeQuestions.map((q) => {
            const questionId = q.questionID ?? q.questionId;
            const attempts = Array.isArray(results[questionId]) ? results[questionId] : [];
            const total = attempts.length;
            const firstTryCorrect = attempts[0]?.is_right === true;
            const hasCorrect = attempts.some((a) => a.is_right === true);

            if (total === 0) unansweredCount += 1;
            else if (firstTryCorrect) correctCount += 1;
            else wrongCount += 1;

            const startedAt = questionStartedAt[questionId];
            const lastAttempt = attempts[attempts.length - 1];
            const durationMs =
                startedAt && lastAttempt?.answered_at
                    ? Math.max(0, lastAttempt.answered_at - startedAt)
                    : 0;

            const cached = questionsCache[questionId];
            const questionText = cached?.question?.text || q.testTitle || '';

            return {
                questionId,
                questionText,
                total,
                firstTryCorrect,
                hasCorrect,
                questionDuration: this.formatDuration(durationMs),
            };
        });

        const totalQuestions = activeQuestions.length;
        const percent = totalQuestions > 0
            ? Math.round((correctCount / totalQuestions) * 100)
            : 0;

        // --- тело запроса ---
        const data = {
            employee,
            trainingType,
            stat: {
                type: trainingTypeName || '',
                employee,
                start_dt: testStartedAt ?? null,
                correctCount,
                wrongCount,
                unansweredCount,
                percent,
                totalDuration: this.formatDuration(totalDurationMs),
            },
            result,
        };

        // --- отправка ---
        try {
            const response = await apiTestTrainings.setResults(data);
            return response?.data ?? null;
        } catch (error) {
            console.error('Не удалось сохранить результат:', error);
            throw error;
        }
    };
    handleExitTimer = () => {};
    handleShowTimer = ()=>{}
    handleTimeExpired = ()=>{}
     renderAdditionalButton = (button) => this.setState({additionalButton: button});
    render() {
        
        const { content,modeSettings, timeLeft, trainingIsFinished, activeQuestions } = this.state;

         if (trainingIsFinished) {
            return (
                <TrainingResultView
                    results={this.state.results}
                    questions={activeQuestions}
                    questionsCache={this.state.questionsCache}
                    testStartedAt={this.state.testStartedAt}
                    testFinishedAt={this.state.testFinishedAt}
                    questionStartedAt={this.state.questionStartedAt}
                    handleExit={this.props.handleExit}
                    handleSaveResult={this.handleSaveResult}
                />
            );
        }

        const showTimer = modeSettings.timeLimit != null && timeLeft != null;
        const isLowTime = showTimer && timeLeft < 60;
        const Content = this.state.content;
        return (
            <>
                <Loader
                                className="h-100"
                                isLoading={this.state.isLoading}
                                loadId="question_training_container"
                                justifyContent="center"
                            >
                    {showTimer && (
                        <div style={{zIndex: '100',
                                    position: 'absolute',
                                    top: '5%',
                                    display: 'flex',
                                    width: '100%',
                                    justifyContent: 'center'}}>
                            <TrainingTimer   secondsLeft={timeLeft}
                            label={this.props.t ? this.props.t('Time left') : 'Осталось'}></TrainingTimer>                    
                        </div>
                        
                    )}
                    {this.state.targetQuestion?
                    <Content
                        onSelectAnswer={this.onSelectAnswer}                
                        load={this.props.load} {...this.state} {...this.props}
                        repeatQuestion={this.repeatQuestion}
                        renderAdditionalButton={this.props.renderAdditionalButton}
                        handleShowTimer={this.handleShowTimer}
                        handleExitTimer={this.handleExitTimer}                          
                        question={this.state.targetQuestion.question}
                        answers = {this.state.targetQuestion.answers}       
                    />:<></>}
                    {!this.state.trainingIsFinished?
                    <StepperNav
                        titleNextStep={this.state.nextTitle??""}
                        activeStep={this.state.currentIndex}
                        listStep={this.state.activeQuestions}
                        additionalButton={this.state.additionalButton} />:""}
                </Loader>
                <ConfirmationDialog
                            open={this.state.showFinishConfirm}
                            title={this.props.t('Завершить тренировку')}
                            message={this.props.t('Вы уверены, что хотите завершить тренировку? Неотвеченные вопросы будут засчитаны как пропущенные.')}
                            confirmText={this.props.t('Завершить')}
                            cancelText={this.props.t('Отмена')}
                            confirmVariant="danger"
                            onConfirm={this.confirmFinish}
                            onCancel={this.closeFinishConfirm}
                        />
            </>

        );
    }
}

const mapStateToProps = (store) => ({
    load: store.loadState,
    theme_name: store.appState.theme_name,
});

export default connect(mapStateToProps)(
    withRouter(withTranslation()(QuestionsTrainingContainer))
);